import { extractData, getFetchOptions } from "../utils";
import { showModalFromHtml } from "../components/modal";
import EventBus from "../events/EventBus";
let instance;
let channel;
let productsList = new Set();
let brandsList = new Set();
// раньше гостевое избранное лежало в Local Storage, теперь его хранит сервер
const LEGACY_LOCAL_STORAGE_NAME = 'favorites';
function initFavorites() {
    if (window.BroadcastChannel) {
        channel = new BroadcastChannel('favorites');
        channel.addEventListener('message', ({ data }) => {
            loadData(data, false);
        });
    }
    loadData(extractData(document.getElementById('favorites-data')));
    importLegacyFavorites();
    return { toggleFavorite, has };
}
export function useFavoritesApi() {
    return instance ?? (instance = initFavorites());
}
async function toggleFavorite(id, brand) {
    const list = brand ? brandsList : productsList;
    const status = await fetch('/api/favorites/toggle', getFetchOptions({ id, brand }, true))
        .then(response => response.json())
        .then(response => {
        if (!response.ok) {
            return list.has(id);
        }
        if (response.html) {
            showModalFromHtml(response.html);
        }
        return response.status;
    });
    if (status) {
        list.add(id);
    }
    else {
        list.delete(id);
    }
    notifyChange();
    return status;
}
function has(id, brand) {
    return brand ? brandsList.has(id) : productsList.has(id);
}
function loadData(data, notify = true) {
    const newProductsList = data?.products ?? [];
    const newBrandsList = data?.brands ?? [];
    if (newProductsList === Array.from(productsList) && newBrandsList === Array.from(brandsList)) {
        return;
    }
    productsList = new Set(newProductsList);
    brandsList = new Set(newBrandsList);
    EventBus.emit('favorites:change');
    if (notify) {
        notifyChange();
    }
}
function notifyChange() {
    channel?.postMessage({
        products: Array.from(productsList),
        brands: Array.from(brandsList),
    });
}
function importLegacyFavorites() {
    const legacy = localStorage.getItem(LEGACY_LOCAL_STORAGE_NAME);
    if (legacy === null) {
        return;
    }
    const data = JSON.parse(legacy);
    fetch('/api/favorites/import', getFetchOptions({ products: data?.products ?? [], brands: data?.brands ?? [] }, true))
        .then(response => response.json())
        .then(response => {
        if (response.ok) {
            localStorage.removeItem(LEGACY_LOCAL_STORAGE_NAME);
            loadData({ products: response.products, brands: response.brands });
        }
    });
}
